var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.5","cx":"15","cy":"15","r":"12","fill":"#1B1C21","key":0}),React.createElement("path",{"d":"M11 20.1169V9.8831C11 9.49445 11.424 9.25439 11.7572 9.45435L20.2854 14.5713C20.6091 14.7655 20.6091 15.2345 20.2854 15.4287L11.7572 20.5457C11.424 20.7456 11 20.5056 11 20.1169Z","fill":"white","key":1})]);
}

PlayButton.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
